export default "__VITE_ASSET__965dd94f__"